<template>
<div
    ref="content"
    id="content-container"
    class="d-flex flex-column"
>
    <exercise-header ref="exerciseHeader" :finished="exerciseFinished" />
    <div
        v-if="exercise.started_confirmation || exerciseFinished || !exercise.time"
        class="container mt-3 px-0"
    >
        <div class="card p-3">
            <h2 class="card-title">{{$t('content.exercise.questions')}}</h2>
            <div
                v-for="(question, index) in exercise.questions"
                :key="question.id"
            >
                <single-answer
                    v-if="question.type === 1"
                    :question="question"
                    :index="index"
                    :isFinished="exerciseFinished"
                    :ref="`question-${question.id}`"
                    :verifyValidate="validError"
                />
                <multiple-answer
                    v-if="question.type === 2"
                    :question="question"
                    :index="index"
                    :isFinished="exerciseFinished"
                    :ref="`question-${question.id}`"
                    :verifyValidate="validError"
                />
                <dissertation-answer
                    v-if="question.type === 3"
                    :question="question"
                    :index="index"
                    :isFinished="exerciseFinished"
                    :ref="`question-${question.id}`"
                />
                <upload-answer
                    v-if="question.type === 4"
                    :index="index"
                    :question="question"
                    :isFinished="exerciseFinished"
                    :ref="`question-${question.id}`"
                    :verifyValidate="validError"
                />
            </div>
            <base-button
                v-if="exerciseFinished && exercise.tries"
                @click="redo"
                :loading="redoLoading"
                :style="[$bgColor(color.primary), { color: color.secondary }]"
                class="mt-5"
            >
                {{$t('lesson.redo')}}
            </base-button>
            <base-button
                v-else-if="exercise.tries"
                @click="submit"
                :loading="redoSubmit"
                class="mt-5"
                :style="[$bgColor(color.primary), { color: color.secondary }]"
            >
                {{$t('lesson.finish_exercise')}}
            </base-button>
            <p v-if="error" class="nch-alert mt-3">
                <i class="mdi mdi-alert"></i>
                {{error}}
            </p>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import SingleAnswer from './ContentExercise/ClassExerciseSingleAnswer';
import MultipleAnswer from './ContentExercise/ClassExerciseMultipleAnswer';
import DissertationAnswer from './ContentExercise/ClassExerciseDissertation';
import UploadAnswer from './ContentExercise/ClassExerciseUpload';

import ExerciseHeader from './ContentExercise/ClassExerciseHeader';
import NavigationControl from '../../../components/Common/NavigationControl';
import ExerciseForumTab from '../.././ExerciseComponents/ExerciseForumTab';

import BaseButton from '../../../argon/components/BaseButton';

export default {
    name: 'ClassContentExercise',
    components: {
        SingleAnswer,
        MultipleAnswer,
        DissertationAnswer,
        UploadAnswer,
        ExerciseHeader,
        NavigationControl,
        ExerciseForumTab,
        BaseButton,
    },

    data() {
        return {
            exerciseFinished: false,
            validError: false,
            redoLoading: false,
            redoSubmit: false,
        };
    },

    watch: {
        exercise: {
            handler(newVal) {
                this.exerciseFinished = !!newVal.finished;
            },
            immediate: true,
            deep: true,
        },
    },

    computed: mapGetters({
        exercise: 'CLASS_EXERCISE',
        contentItem: 'CLASS_CONTENT_ITEM',
        color: 'COLOR',
        error: 'CLASS_EXERCISE_ERROR',
    }),

    methods: {
        async submit() {
            const success = this.exercise.questions.map(question => this.$refs[`question-${question.id}`][0].$validator.validateAll());

            const promises = await Promise.all(success);
            const valid = promises.every(validation => validation);
            if (valid) {
                this.validError = false;
                this.redoSubmit = true;


                this.$store.dispatch('CLASS_EXERCISE_SUBMIT');
                await this.$store.dispatch('CLASS_GET_EXERCISE_PROGRESS');
                this.$refs.content.scrollTop = 0;

                this.redoSubmit = false;
            } else {
                this.validError = true;
                this.$notify({
                    type: 'danger',
                    message: this.$t('exercise.validate.some_question_no_anwser'),
                });
            }
        },
        async redo() {
            this.redoLoading = true;
            await this.$store.dispatch('CLASS_EXERCISE_REDO');
            this.$emit('contentSubmited');
            this.$refs.content.scrollTop = 0;

            if (this.exercise.time) {
                await this.$store.dispatch('CLASS_EXERCISE_GET_STUDENT_TIME');
                this.$refs.exerciseHeader.$refs.timer.startExercise();
            }
            this.redoLoading = false;
        },
    },
};
</script>

<style lang="sass">
.nch-alert
    color: crimson
    font-style: italic

.btn-group
    cursor: pointer
</style>

<style lang="sass" scoped>
.stretch
    height: 100%
    overflow: auto
    border-radius: 0
</style>
